import { defineComponent as _defineComponent } from 'vue'
import CommonApi from '@/services/api/CommonApi'
  import { ref, watch } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelector',
  emits: ['selected-country'],
  setup(__props, { emit }) {

  

  const selectedCountry = ref('DE')
  const countries = ref([] as { code: string; name: string }[])

  const fetchCountries = () => {
    CommonApi.fetchCountries().then((countriesData: any[]) => {
      countries.value = countriesData
        .map((country) => ({
          code: country.cca2,
          name: country.name.common,
        }))
        .sort((a, b) => a.name.localeCompare(b.name))

      emit('selected-country', 'DE')
    })
  }

  watch(selectedCountry, (value) => {
    emit('selected-country', value)
  })

  fetchCountries()

return { __sfc: true,emit, selectedCountry, countries, fetchCountries, CommonApi, ref, watch }
}

})